import React from 'react';
import { gikClassPrefix } from '@gik/core/constants';
import classnames from 'classnames';
import FrameBone, { FrameBoneProps } from '@gik/ui/SkeletonLoader/Bones/FrameBone';

const blockName = `${gikClassPrefix}-circle-bone`;

export interface CircleBoneBoneProps extends FrameBoneProps {}

export default function CircleBone({ className, children }: CircleBoneBoneProps) {
  const blockClasses = classnames([blockName, className || '']);

  return <FrameBone className={blockClasses}>{children}</FrameBone>;
}
